/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
 
 {
    
    description:
      'FIELD TRIP CLASS 6',
    href : '/field-trip-class-6'
 
  }, {
    
    description:
      'FIELD TRIP CLASS 7',
    href : '/field-trip-class-7'
  },
   {
    
    description:
      'FIELD TRIP CLASS 8',
    href : '/field-trip-class-8'
 
  },
   {
    description:
      'FIELD TRIP CLASS 9',
    href : '/field-trip-class-9-2026'
 
  },
  {
    description:
      'FIELD TRIP CLASS 10',
    href : '/field-trip-class-10-2026'
  },
  {
    description:
      'FIELD TRIP CLASS 11-12',
    href : '/field-trip-class-11-12-2026'
  },
  {
    description:
      'EDUCATIONAL TRIP CLASS 10',
    href : '/educational-trip-class-10-2026'
  },
  {
    description:
      'Visit to Artisan Haat',
    href : '/visit-artisan-haat-2026'
  },
  {
    description:
      'Visit to GKVK',
    href : '/visit-gkvk-2026'
  },
  {
    description:
      'Visit to Britannia Industries',
    href : '/visit-britannia-industries-2026'
  },
  {
    description:
      'Visit to orphanage',
    href : '/visit-orphanage-2026'
  },
  {
    description:
      'Visit to Science Gallery',
    href : '/visit-science-gallery-2026'
  }

]

const CoScholacticSidebar2026 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
       Extracurricular Activities 2026-27
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'h6'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CoScholacticSidebar2026;
